import { useState } from "react";
import { Mountain, Loader2 } from "lucide-react";
import { login as apiLogin, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const { signIn } = useAuth();

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const data = await apiLogin(email, password);
      signIn(data.access_token, data.user);
      // Full page reload avoids any client-side routing quirks.
      window.location.href = "/admin";
    } catch (e2) {
      setErr(formatApiError(e2.response?.data?.detail) || "Login failed");
      setLoading(false);
    }
  };

  const cls = "bg-forest-900 border-forest-700 text-sage-100 focus-visible:ring-golden-500 rounded-sm h-12";

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center px-6 bg-forest-950">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2 mb-10 justify-center">
          <Mountain className="h-7 w-7 text-golden-500" />
          <span className="font-serif text-3xl text-sage-100">Cascade<span className="text-golden-500">.</span></span>
        </div>
        <div className="bg-forest-900 border border-forest-700 rounded-sm p-8">
          <h1 className="font-serif text-3xl text-sage-100 mb-2">Admin sign in</h1>
          <p className="text-sage-400 text-sm mb-8">Manage bookings, toolkits and resources.</p>
          <form onSubmit={submit} className="space-y-5">
            <div className="space-y-2">
              <Label className="text-sage-200 text-sm">Email</Label>
              <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="susan@cascadehradvisors.com" className={cls} />
            </div>
            <div className="space-y-2">
              <Label className="text-sage-200 text-sm">Password</Label>
              <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className={cls} />
            </div>
            {err && <p data-testid="login-error" className="text-sm text-red-400">{err}</p>}
            <button data-testid="login-submit" type="submit" disabled={loading} className="w-full flex items-center justify-center gap-2 bg-golden-500 text-navy font-semibold h-12 rounded-sm transition-colors duration-300 hover:bg-golden-600 disabled:opacity-60">
              {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Sign in"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
